import groq from 'groq';

import { PRODUCT_BUNDLE_IN_BLOCK } from '../product';

export const PRODUCT_BUNDLE_BLOCK = groq`
  _type == 'productBundle' => {
    ${PRODUCT_BUNDLE_IN_BLOCK}
  }
`;
